import { setRates } from "./locale";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DESTINATIONS, APPLY_PLANS, PARTNERS } from "../mock";
import { optimizeDestination } from "./img";
import { appReady } from "./defer";

const API = process.env.REACT_APP_BACKEND_URL;
const Ctx = createContext({ version: 0, refresh: () => {}, live: false, ready: false });

const fill = (arr, items) => arr.splice(0, arr.length, ...items);

export function applyOverrides(items) {
  fill(DESTINATIONS, items.map((d) => optimizeDestination(d)));
}

export function DestinationsProvider({ children }) {
  const [version, setVersion] = useState(0);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const refresh = useCallback(async () => {
    setError(null);
    try {
      const [d, p, pa, fees] = await Promise.all(["/api/destinations", "/api/plans", "/api/partners", "/api/fees"].map((u) => fetch(`${API}${u}`).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })));
      fill(DESTINATIONS, (d.items || []).map((x) => optimizeDestination(x)));
      fill(APPLY_PLANS, p.items || []);
      fill(PARTNERS, pa.items || []);
      if (fees?.fx) setRates(fees.fx.rates, { provider: fees.fx.provider, fetched_at: fees.fx.fetched_at, markup_pct: fees.fx.markup_pct });
      setReady(true);
      setVersion((v) => v + 1);
      appReady();
    } catch (e) { setError(e); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  if (!ready) {
    return (
      <div className="grid min-h-screen place-items-center bg-background" data-testid="catalogue-loading">
        {error ? (
          <div className="text-center">
            <p className="font-semibold">We couldn't load destinations right now.</p>
            <button type="button" onClick={refresh} className="mt-4 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground" data-testid="catalogue-retry">Try again</button>
          </div>
        ) : <span className="h-8 w-8 animate-spin rounded-full border-2 border-gray4 border-t-primary" aria-label="Loading" />}
      </div>
    );
  }
  return <Ctx.Provider value={{ version, refresh, live: true, ready }}>{children}</Ctx.Provider>;
}

export const useDestinations = () => useContext(Ctx);
